module.exports = __webpack_public_path__ + "img/wen.5681ecbf.png";